import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {ScheduledTask, ScheduledTaskSearchParams} from '@accounting/_common/models/scheduled-task.models';

export const CheckState = createAction(
    '[ScheduledTasks] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: ScheduledTask[] } }>()
);

export const CheckStateSuccess = createAction(
    '[ScheduledTasks] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: ScheduledTask[] } }>()
);

export const LoadList = createAction(
    '[ScheduledTasks] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[ScheduledTasks] Load List Success',
    props<{ payload: { items: ScheduledTask[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[ScheduledTasks] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[ScheduledTasks] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[ScheduledTasks] Set Filter',
    props<{ payload: ScheduledTaskSearchParams }>()
);

export const SetLoading = createAction(
    '[ScheduledTasks] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[ScheduledTasks] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[ScheduledTasks] Update Item Success',
    props<{ payload: ScheduledTask }>()
);

export const DeleteItem = createAction(
    '[ScheduledTasks] Delete Item',
    props<{ payload: ScheduledTask }>()
);

export const DeleteItemSuccess = createAction(
    '[ScheduledTasks] Delete Item Success',
    props<{ payload: ScheduledTask }>()
);

export const DeleteItemFailure = createAction(
    '[ScheduledTasks] Delete Item Failure',
    props<{ payload: ScheduledTask }>()
);

export const SetInitialState = createAction(
    '[ScheduledTasks] Set Initial State'
);

export const UpdateScheduledTaskItem = createAction(
    '[ScheduledTasks] Update ScheduledTask Item',
    props<{ payload: ScheduledTask }>()
);
